import React, { ClassAttributes, HTMLAttributes, forwardRef } from "react";

import "./modal.css";

export interface ModalActionsUIProps {}

export type ModalActionsProps = HTMLAttributes<HTMLElement> &
    ModalActionsUIProps &
    ClassAttributes<HTMLElement>;

const ModalActions = forwardRef<HTMLElement, ModalActionsProps>((props, ref) => {
    const { className, children, ...rest } = props;

    const classes = ["modal-actions", className].filter(Boolean).join(" ");

    return (
        <section
            {...rest}
            ref={ref as any}
            className={classes}
        >
            {children}
        </section>
    );
});

ModalActions.displayName = "ModalActions";

export default ModalActions;
